import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=031cf460"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports